// import React, { Component } from "react";

// // reactstrap components
// import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
// import ChromeCheck from "views/ChromeCheckGlobal.jsx";
// import API from "../api";
// import { Navigate } from "react-router-dom";
// import { userContext } from "userContext";
// import { Helmet } from "react-helmet";
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// import NotificationAlert from "react-notification-alert";
// import { setUser, expVidPopup } from "action/index.js";
// import { connect } from "react-redux";
// import { Grid } from "@mui/material";
// import AiImage from "assets/images/images_new/ai.png";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
// import "assets/css/material-style.css";
// import SubcategoryTitle from "Datasets/SubcategoryTitle.json";
// import SpeakingZone from "assets/images/images_new/microphone-icon.svg";
// import WritingZone from "assets/images/images_new/writing-icon.png";
// import ReadingZone from "assets/images/images_new/reading-icon.png";
// import ListeningZone from "assets/images/images_new/listening-icon.png";
// import PracticeTour from "components/WebsiteTour/PracticeTour";

// const mapStateToProps = (state) => {
//   return {
//     user: state.user,
//     expVidPopup: state.expVidPopup,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUser: (user) => dispatch(setUser(user)),
//     setExpVidPopup: (count) => dispatch(expVidPopup(count)),
//   };
// };

// class Material extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       redirect: false,
//       type: 0,
//       all_ok: true,
//       categoryData: [],
//     };
//   }

//   // componentWillUnmount() {
//   //   document.body.classList.remove("leftSidebarClosed");
//   // }

//   componentDidMount() {
//     // Add this on priority
//     // document.body.classList.add("leftSidebarClosed");

//     this.setSubcategories();

//     if (
//       this.props.user.active_subscription.length > 0 &&
//       this.props.user.active_subscription[0].plan.is_gold === 1
//     ) {
//       this.props.setExpVidPopup(0);
//     }
//     const fetch = async () => {
//       try {
//         let response = await API("/getTokens");
//         if (response.status === 200) {
//           // console.log(response);
//         } else {
//           this.notify(2, "Something went wrong");
//         }
//       } catch (e) {}
//     };

//     fetch();
//   }

//   setSubcategories = () => {
//     const data = [
//       {
//         zone: "Speaking",
//         subcategories: [
//           {
//             id: 1,
//             name: SubcategoryTitle[1],
//             ai: true,
//           },
//           {
//             id: 2,
//             name: SubcategoryTitle[2],
//             ai: true,
//           },
//           {
//             id: 3,
//             name: SubcategoryTitle[3],
//             ai: true,
//           },
//           {
//             id: 4,
//             name: SubcategoryTitle[4],
//             ai: true,
//           },
//           {
//             id: 5,
//             name: SubcategoryTitle[5],
//             ai: true,
//           },
//         ],
//       },
//       {
//         zone: "Writing",
//         subcategories: [
//           {
//             id: 6,
//             name: SubcategoryTitle[6],
//             ai: true,
//           },
//           {
//             id: 7,
//             name: SubcategoryTitle[7],
//             ai: true,
//           },
//         ],
//       },
//       {
//         zone: "Reading",
//         subcategories: [
//           {
//             id: 12,
//             name: SubcategoryTitle[12],
//             ai: false,
//           },
//           {
//             id: 9,
//             name: SubcategoryTitle[9],
//             ai: false,
//           },
//           {
//             id: 10,
//             name: SubcategoryTitle[10],
//             ai: false,
//           },
//           {
//             id: 11,
//             name: SubcategoryTitle[11],
//             ai: false,
//           },
//           {
//             id: 8,
//             name: SubcategoryTitle[8],
//             ai: false,
//           },
//         ],
//       },
//       {
//         zone: "Listening",
//         subcategories: [
//           {
//             id: 13,
//             name: SubcategoryTitle[13],
//             ai: true,
//           },
//           {
//             id: 14,
//             name: SubcategoryTitle[14],
//             ai: false,
//           },
//           {
//             id: 15,
//             name: SubcategoryTitle[15],
//             ai: false,
//           },
//           {
//             id: 16,
//             name: SubcategoryTitle[16],
//             ai: false,
//           },
//           {
//             id: 17,
//             name: SubcategoryTitle[17],
//             ai: false,
//           },
//           {
//             id: 18,
//             name: SubcategoryTitle[18],
//             ai: false,
//           },
//           {
//             id: 19,
//             name: SubcategoryTitle[19],
//             ai: false,
//           },
//           {
//             id: 20,
//             name: SubcategoryTitle[20],
//             ai: false,
//           },
//         ],
//       },
//     ];

//     this.setState({
//       categoryData: data,
//     });
//   };

//   showQuestion(type) {
//     this.setState({ redirect: true, type: type });
//   }

//   notify = (type, message) => {
//     switch (type) {
//       case 1:
//         type = "success";
//         break;
//       case 2:
//         type = "danger";
//         break;
//       default:
//         break;
//     }
//     var options = {};
//     options = {
//       place: "tr",
//       message: (
//         <div>
//           <div>{message}</div>
//         </div>
//       ),
//       type: type,
//       icon: "now-ui-icons ui-1_bell-53 fa fa-bell",
//       autoDismiss: 10,
//     };
//     this.refs.notificationAlert.notificationAlert(options);
//   };

//   renderSection = (section) => {
//     const { categoryData } = this.state;
//     let selected = null;

//     switch (section) {
//       case "Speaking":
//         selected = categoryData[0];
//         break;
//       case "Writing":
//         selected = categoryData[1];
//         break;
//       case "Reading":
//         selected = categoryData[2];
//         break;
//       case "Listening":
//         selected = categoryData[3];
//         break;
//     }

//     console.log("loading practice material questions");
    

//     let html = "";
//     if (selected) {
//       html = selected.subcategories.map((item, i) => {
//         return (
//           <div
//             className="pm-card-outer cursor-pointer"
//             onClick={this.showQuestion.bind(this, item.id)}
//             key={i}
//           >
//             <div className="pm-card">
//               <div className="pm-card-content">
//                 <h2 className="pm-card-title">{item.name}</h2>
//                 {item.ai && (
//                   <img className="pm-card-img" src={AiImage} alt={item.name} />
//                 )}
//               </div>
//               <div className="pm-card-btn">VIEW</div>
//             </div>
//           </div>
//         );
//       });
//     }

//     return html;
//   };

//   render() {
//     if (this.state.redirect) {
//       return (
//         <Navigate to={"/admin/questionList/0/" + this.state.type} replace />
//       );
//     }

//     return (
//       <>
//         <Helmet>
//           <title>Top PTE Training Institute</title>
//         </Helmet>

//         <div className="notification-div">
//           <NotificationAlert ref="notificationAlert" zIndex={9999} />
//         </div>

//         {!this.state.all_ok && <ChromeCheck />}

//         {this.state.all_ok && (
//           // <div className="siteContent multipleCards">
//            <div className="content p-0">
//             <DashboardHeader title="Practice Material" />

//             <Row>
//               <div className="practice-material-categories dashboard-content-wrapper pm-categories !m-0">
//                 <div className="pm-wrapper-outer speaking" id="Speaking-Zone">
//                   <div className="pm-wrapper">
//                     <h2 className="pm-title">
//                       <img
//                         src={SpeakingZone}
//                         className="me-2"
//                         alt="speaking-zone"
//                         style={{
//                           width: "18px",
//                         }}
//                       />{" "}
//                       Speaking Zone
//                     </h2>
//                     <div className="pm-row">
//                       {this.renderSection("Speaking")}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="pm-wrapper-outer writing" id="Writing-Zone">
//                   <div className="pm-wrapper">
//                     <h2 className="pm-title">
//                       <img
//                         src={WritingZone}
//                         className="me-2"
//                         alt="writing-zone"
//                         style={{
//                           width: "22px",
//                         }}
//                       />{" "}
//                       Writing Zone
//                     </h2>
//                     <div className="pm-row">
//                       {this.renderSection("Writing")}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="pm-wrapper-outer reading" id="Reading-Zone">
//                   <div className="pm-wrapper">
//                     <h2 className="pm-title">
//                       <img
//                         src={ReadingZone}
//                         className="me-2"
//                         alt="reading-zone"
//                         style={{
//                           width: "22px",
//                         }}
//                       />
//                       Reading Zone
//                     </h2>
//                     <div className="pm-row">
//                       {this.renderSection("Reading")}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="pm-wrapper-outer listening" id="Listening-Zone">
//                   <div className="pm-wrapper">
//                     <h2 className="pm-title">
//                       <img
//                         src={ListeningZone}
//                         className="me-2"
//                         alt="listening-zone"
//                         style={{
//                           width: "22px",
//                         }}
//                       />
//                       Listening Zone
//                     </h2>
//                     <div className="pm-row">
//                       {this.renderSection("Listening")}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </Row>
//             <PracticeTour />
//           </div>
//         )}
//       </>
//     );
//   }
// }
// export default connect(mapStateToProps, mapDispatchToProps)(Material);

import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import ChromeCheck from "views/ChromeCheckGlobal.jsx";
import API from "../api";
import { Navigate } from "react-router-dom";
import { userContext } from "userContext";
import { Helmet } from "react-helmet";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// import NotificationAlert from "react-notification-alert";
import { setUser, expVidPopup } from "action/index.js";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import AiImage from "assets/images/images_new/ai.png";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import "assets/css/material-style.css";
import SubcategoryTitle from "Datasets/SubcategoryTitle.json";
import SpeakingZone from "assets/images/images_new/microphone-icon.svg";
import WritingZone from "assets/images/images_new/writing-icon.png";
import ReadingZone from "assets/images/images_new/reading-icon.png";
import ListeningZone from "assets/images/images_new/listening-icon.png";
// import PracticeTour from "components/WebsiteTour/PracticeTourShepherd";

const mapStateToProps = (state) => {
  return {
    user: state.user,
    expVidPopup: state.expVidPopup,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (user) => dispatch(setUser(user)),
    setExpVidPopup: (count) => dispatch(expVidPopup(count)),
  };
};

const Material = (props) => {
  const [data, setData] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [type, setType] = useState(0);
  const [all_ok, setAll_ok] = useState(true);
  const [categoryData, setCategoryData] = useState([]);
  // const notificationAlert = React.createRef();

  // componentWillUnmount equivalent
  // useEffect(() => {
  //   return () => {
  //     document.body.classList.remove("leftSidebarClosed");
  //   };
  // }, []);

  useEffect(() => {
    // Add this on priority
    // document.body.classList.add("leftSidebarClosed");

    setSubcategories();
    if(props?.user?.active_subscription.length > 0){
    if (
      props?.user?.active_subscription[0]?.plan &&
      props?.user?.active_subscription[0]?.plan?.is_gold === 1
    ) {
      props.setExpVidPopup(0);
    }
    }
  
    
    const fetch = async () => {
      try {
        let response = await API("/getTokens");
        if (response.status === 200) {
          // console.log(response);
        } else {
          notify(2, "Something went wrong");
        }
      } catch (e) {}
    };

    fetch();
  }, []);

  const setSubcategories = () => {
    const data = [
      {
        zone: "Speaking",
        subcategories: [
          {
            id: 1,
            name: SubcategoryTitle[1],
            ai: true,
          },
          {
            id: 2,
            name: SubcategoryTitle[2],
            ai: true,
          },
          {
            id: 3,
            name: SubcategoryTitle[3],
            ai: true,
          },
          {
            id: 4,
            name: SubcategoryTitle[4],
            ai: true,
          },
          {
            id: 5,
            name: SubcategoryTitle[5],
            ai: true,
          },
          //  {
          //   id: 22,
          //   name: SubcategoryTitle[22],
          //   ai: true,
          // },
          //  {
          //   id: 21,
          //   name: SubcategoryTitle[21],
          //   ai: true,
          // }
         
        ],
      },
      {
        zone: "Writing",
        subcategories: [
          {
            id: 6,
            name: SubcategoryTitle[6],
            ai: true,
          },
          {
            id: 7,
            name: SubcategoryTitle[7],
            ai: true,
          },
        ],
      },
      {
        zone: "Reading",
        subcategories: [
          {
            id: 12,
            name: SubcategoryTitle[12],
            ai: false,
          },
          {
            id: 9,
            name: SubcategoryTitle[9],
            ai: false,
          },
          {
            id: 10,
            name: SubcategoryTitle[10],
            ai: false,
          },
          {
            id: 11,
            name: SubcategoryTitle[11],
            ai: false,
          },
          {
            id: 8,
            name: SubcategoryTitle[8],
            ai: false,
          },
        ],
      },
      {
        zone: "Listening",
        subcategories: [
          {
            id: 13,
            name: SubcategoryTitle[13],
            ai: true,
          },
          {
            id: 15,
            name: SubcategoryTitle[15],
            ai: false,
          },
          {
            id: 16,
            name: SubcategoryTitle[16],
            ai: false,
          },
          {
            id: 14,
            name: SubcategoryTitle[14],
            ai: false,
          },
          {
            id: 18,
            name: SubcategoryTitle[17],
            ai: false,
          },
          {
            id: 19,
            name: SubcategoryTitle[18],
            ai: false,
          },
          {
            id: 20,
            name: SubcategoryTitle[19],
            ai: false,
          },
          // {
          //   id: 20,
          //   name: SubcategoryTitle[20],
          //   ai: false,
          // },
        ],
      },
    ];

    setCategoryData(data);
  };

  const showQuestion = (type) => {
    setRedirect(true);
    setType(type);
  };

  const notify = (type, message) => {
    switch (type) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: "tr",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "now-ui-icons ui-1_bell-53 fa fa-bell",
      autoDismiss: 10,
    };
    // notificationAlert.current.notificationAlert(options);
  };

  const renderSection = (section) => {
    let selected = null;

    switch (section) {
      case "Speaking":
        selected = categoryData[0];
        break;
      case "Writing":
        selected = categoryData[1];
        break;
      case "Reading":
        selected = categoryData[2];
        break;
      case "Listening":
        selected = categoryData[3];
        break;
    }

    let html = "";
    if (selected) {
      html = selected.subcategories.map((item, i) => {
        return (
          <div
            className="pm-card-outer cursor-pointer"
            onClick={() => showQuestion(item.id)}
            key={i}
          >
            <div className="pm-card">
              <div className="pm-card-content">
                <h2 className="pm-card-title">{item.name}</h2>
                {item.ai && (
                  <img className="pm-card-img" src={AiImage} alt={item.name} />
                )}
              </div>
              <div className="pm-card-btn">VIEW</div>
            </div>
          </div>
        );
      });
    }

    return html;
  };

  if (redirect) {
    return (
      <Navigate to={"/admin/questionList/0/" + type} />
    );
  }

  return (
    <>
      <Helmet>
        <title>Top PTE Training Institute</title>
      </Helmet>

      <div className="notification-div">
        {/* <NotificationAlert ref={notificationAlert} zIndex={9999} /> */}
      </div>

      {!all_ok && <ChromeCheck />}

      {all_ok && (
        // <div className="siteContent multipleCards">
         <div className="content p-0">
          <DashboardHeader title="Practice Material" />
            {/* <PracticeTour /> */}

          <Row>
            <div className="practice-material-categories dashboard-content-wrapper pm-categories !m-0">
              <div className="pm-wrapper-outer speaking" id="Speaking-Zone">
                <div className="pm-wrapper">
                  <h2 className="pm-title">
                    <img
                      src={SpeakingZone}
                      className="me-2"
                      alt="speaking-zone"
                      style={{
                        width: "18px",
                      }}
                    />{" "}
                    Speaking Zone
                  </h2>
                  <div className="pm-row">
                    {renderSection("Speaking")}
                  </div>
                </div>
              </div>
              <div className="pm-wrapper-outer writing" id="Writing-Zone">
                <div className="pm-wrapper">
                  <h2 className="pm-title">
                    <img
                      src={WritingZone}
                      className="me-2"
                      alt="writing-zone"
                      style={{
                        width: "22px",
                      }}
                    />{" "}
                    Writing Zone
                  </h2>
                  <div className="pm-row">
                    {renderSection("Writing")}
                  </div>
                </div>
              </div>
              <div className="pm-wrapper-outer reading" id="Reading-Zone">
                <div className="pm-wrapper">
                  <h2 className="pm-title">
                    <img
                      src={ReadingZone}
                      className="me-2"
                      alt="reading-zone"
                      style={{
                        width: "22px",
                      }}
                    />
                    Reading Zone
                  </h2>
                  <div className="pm-row">
                    {renderSection("Reading")}
                  </div>
                </div>
              </div>
              <div className="pm-wrapper-outer listening" id="Listening-Zone">
                <div className="pm-wrapper">
                  <h2 className="pm-title">
                    <img
                      src={ListeningZone}
                      className="me-2"
                      alt="listening-zone"
                      style={{
                        width: "22px",
                      }}
                    />
                    Listening Zone
                  </h2>
                  <div className="pm-row">
                    {renderSection("Listening")}
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </div>
      )}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Material);